import React, { useState } from "react";


// icons
import { MdKeyboardArrowRight } from "react-icons/md";
import { HiPlus, HiMinus } from "react-icons/hi";

// react router
import { Link } from "react-router-dom";

export default function Dropdown(props) {
    // props
    const {
        label,
        menuItem,

        setMobileMenuVisibility
    } = props;

    // consts
    const MOBILE_WIDTH_TO_SHOW_MENU = 992

    // states
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // to toggle mobile menu
    const toggleMobileMenu = ev => {
        ev.preventDefault()
        ev.stopPropagation()

        setIsDropdownOpen(!isDropdownOpen) // toggeling the dropdown
    }

    return (
        <div
            className={`dropdown-main ${isDropdownOpen ? "active" : ""}`}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
        >
            <Link
                to={`/category/${menuItem.category_url}?id=${menuItem.category_id}`}
                className="text-decoration-none d-flex align-items-center"
                onClick={() => {
                    setIsDropdownOpen(false) // setting the dropdown

                    setMobileMenuVisibility(false) // close mobile menu
                }}
            >
                <div className="label-outer text-uppercase st-fs-13 cursor-pointer d-flex align-items-center st-fw-800 media-body">
                    <span>
                        {label}
                    </span>

                    {/* icon */}
                    <div className="icon d-none d-lg-block">
                        <MdKeyboardArrowRight className="on-md ms-1" fontSize="17" />
                    </div>
                </div>

                {/* mobile icon */}
                <div className="mobile-icon d-lg-none ms-auto" onClick={toggleMobileMenu}>
                    {
                        isDropdownOpen ? (
                            <HiMinus className="on-md" fontSize="16" />
                        ) : (
                            <HiPlus className="on-md" fontSize="16" />
                        )
                    }
                </div>
            </Link>

            {/* dropdown-content */}
            <div className="dropdown-content">
                {
                    menuItem?.sub_categories?.length ? menuItem.sub_categories.map(item => (
                        <Link
                            key={item.category_id}
                            to={`/shop/${item.category_url}?id=${item.category_id}`}
                            className="text-decoration-none text-uppercase"
                            onClick={() => {
                                setIsDropdownOpen(false) // setting the dropdown
                                
                                setMobileMenuVisibility(false) // close mobile menu
                            }}
                        >
                            <div className="menu-link" key={item.category_id}>{item.category_name}</div>
                        </Link>
                    )) : null
                }
            </div>
        </div>
    )
}
